import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDealInsightsContext } from '../../context/DealInsightsContext';
import { DistributionSection } from './components/DistributionSection';
import { mapDistributionsApiData } from './utils/mapDistributionsApiData';

export const DealInsightsDistribution = () => {
  const { t } = useTranslation();

  const {
    dealInsights: { data, chartsLoadingState },
  } = useDealInsightsContext();

  const isLoading = !!chartsLoadingState.inventory_distributions;

  const { spend, impressions, clicks } = useMemo(
    () => mapDistributionsApiData(t, data?.inventory_distributions),
    [data, t]
  );

  return (
    <Box component="section" data-test="deal-insights-distribution">
      <DistributionSection title={t('Spend')} data={spend} isLoading={isLoading} />
      <Divider sx={{ my: 3 }} />
      <DistributionSection title={t('Impressions')} data={impressions} isLoading={isLoading} />
      <Divider sx={{ my: 3 }} />
      <DistributionSection title={t('Clicks')} data={clicks} isLoading={isLoading} />
    </Box>
  );
};
